import { Address, orUndefined, schFormNumber } from '@aloft/toolkit-shared';

import { isNil } from 'lodash';

import { getAttribute } from './getAttribute.ts';

export function extractLocationTag(sale: Element): {
  address?: Address;
  latitude?: number;
  longitude?: number;
} {
  try {
    const location = sale.getElementsByTagName('LOCATION')[0];
    const latitude = orUndefined(schFormNumber.parse)(getAttribute(location, 'LatitudeNumber'));
    const longitude = orUndefined(schFormNumber.parse)(getAttribute(location, 'LongitudeNumber'));
    const address: Address = {};
    address.AddressLineText = getAttribute(location, 'PropertyStreetAddress');
    const cityName = getAttribute(location, 'PropertyCity');
    const stateCode = getAttribute(location, 'PropertyState');
    const postalCode = getAttribute(location, 'PropertyPostalCode');
    if ([cityName, stateCode, postalCode].every(isNil)) {
      /**
       * Subject comp sale only has PropertyStreetAddress2, not broken down into city, state, zip.
       * Additionally, some form fillers (ClickForms) only include PropertyStreetAddress2 for all
       * comps. This is technically not UAD-compliant, but supporting it anyways.
       */
      const streetAddress2Regex = new RegExp(/^([\w\s]*), (\w{2}) (\d{5})(-\d{4})?$/);
      const matches = getAttribute(location, 'PropertyStreetAddress2')?.match(streetAddress2Regex);
      if (matches) {
        address.CityName = matches[1];
        address.StateCode = matches[2];
        address.PostalCode = matches[3];
      }
    } else {
      address.CityName = cityName;
      address.StateCode = stateCode;
      address.PostalCode = postalCode;
    }

    return {
      address,
      latitude,
      longitude,
    };
  } catch (e: unknown) {
    console.warn('Failed to parse location tag', e);
    return {};
  }
}
